import MfaSetupPush from './MfaSetupPush';

export default MfaSetupPush;